module.exports = __webpack_public_path__ + "static/media/ourPresence.93866304.jpg";